
import { mapGetters } from "vuex";
import { getImageByPosition, metaGenerator, normalizeI18nLinks, getPageFromQuery } from "@/utils";
import useEvents from "~/mixins/useEvents";
import ArticlesList from "@/components/pages/articles/ArticlesList.vue";

export default {
  name: "Index",
  components: {
    ArticlesList,
  },
  mixins: [useEvents],
  async asyncData({ $api, query, store, i18n, route, error }) {
    const getPage = async () => {
      try {
        const { data } = await $api.pages.getPage("posts");
        return data.data;
      } catch (err) {
        console.log("err - ", err?.response?.data?.errors);
        error({ statusCode: err.response.status });
      }
    };

    const getCategories = async () => {
      try {
        const { data } = await $api.blog.getBlogCategories();
        return data.data?.filter((el) => el.status) || [];
      } catch (err) {
        console.log("err - ", err?.response?.data?.errors);
      }
    };

    const pageData = await getPage();

    store.commit("general/SET_JSON_SCHEMA_DATA", {
      pageName: i18n.t("articles"),
      pageImage:
        getImageByPosition(pageData?.medias, "page")?.file?.url ||
        getImageByPosition(pageData?.medias, "list")?.file?.url,
    });

    return {
      pageData,
      blogCategories: await getCategories(),
      search: query.search,
    };
  },
  head() {
    const i18nHead = this.$nuxtI18nHead({
      addSeoAttributes: {
        // TODO remove after reindex
        canonicalQueries: getPageFromQuery(this.$route.query.page) === 1 ? false : ["page"],
      },
    });
    const titleTemplate = `%s | ${this.getCompanyName}`;
    let description = this.$t("ourBlog");
    const currentPage = getPageFromQuery(this.$route.query.page);

    if (currentPage > 1) {
      description += ` | ${this.$t("page")} ${currentPage}`;
    }
    return {
      meta: [
        ...metaGenerator({
          title:
            this.pageData?.mixedTranslation?.meta_title ||
            this.pageData?.mixedTranslation?.title ||
            "",
          description,
          image:
            this.pageData?.medias?.find((el) => el.position === "open-graph")
              ?.file?.url || "",
          keywords: this.pageData?.mixedTranslation?.meta_keywords || "",
          url:
            this.pageData?.mixedTranslation?.meta_url ||
            process.env.DOMAIN + this.$route.fullPath,
          company_name: this.getCompanyName,
          titleTemplate,
        }),
        ...i18nHead.meta,
      ],
      htmlAttrs: i18nHead.htmlAttrs,
      link: normalizeI18nLinks(i18nHead.link),
      title:
        this.pageData?.mixedTranslation?.meta_title || this.pageData?.mixedTranslation?.title || "",
      titleTemplate,
    };
  },
  computed: {
    ...mapGetters({
      getCompanyName: "general/getCompanyName",
    }),
  },
  mounted () {
    this.visitEvent(this.pageData?.is_plp);
  },
  methods: {
    onSearch() {
      const path = `${this.$route.path}?search=${this.search}`;
      this.$router.push(path);
    },
  },
};
